import { Button } from '@mui/material';
import * as React from 'react';
import { Customer } from 'types/Customer';
import { CustomerTag } from './CustomerTag';
import { TagSearch } from './search';

export interface Props {
  /** Fired when the user chooses or clears the customer */
  setCustomer: (customer: Customer | null, close?: boolean) => void;
  /** The customer (or not) to show as selected */
  customer: Customer | null;
  /** Fired when the user clicks to choose a customer  */
  setIsOpen: (open: boolean) => void;
  /** Shows the actual picker when true */
  isOpen: boolean;
  /** Additional classes to apply to the picker */
  className?: string;
}

/**
 * This component will be responsible for rendering the three different states of the customer button;
 * - The initial button state
 * - The intermediate text / dropdown state
 * - The set state w/ edit button
 * It must be fully controlled by its parent; it does not keep any state and thus must be fully controlled
 * via props.
 */
export const ControlledAssignButton: React.FC<Props> = (props) => {
  const { customer, setCustomer, setIsOpen, isOpen, className } = props;

  let inner: React.ReactNode | null = null;

  if (customer) {
    inner = (
      <div className="space-x-2 flex items-center">
        <CustomerTag customer={customer} />
        <h5 className="underline text-blue-900 cursor-pointer" onClick={() => setIsOpen(true)}>
          Edit
        </h5>
      </div>
    );
  } else {
    inner = (
      // eslint-disable-next-line
        // @ts-ignore
      <Button onClick={() => setIsOpen(true)} variant="contained" color="primary">
        Select or create a Reference ID
      </Button>
    );
  }

  if (isOpen) {
    inner = (
      <TagSearch
        onSelect={(c) => setCustomer(c, !!c)}
        onClickAway={() => setIsOpen(false)}
        customer={customer}
        className={className}
      />
    );
  }

  return (
    <div className="space-y-2">
      <h5 className="text-gray-800">Up to 40 characters</h5>
      {inner}
    </div>
  );
};
ControlledAssignButton.displayName = 'CustomerTag.ControlledAssignButton';
